import { createSlice } from '@reduxjs/toolkit';

export const friendSlice = createSlice({
    name: 'settingsReducer',
    initialState: {
        friends: [],
        pendingFriends: [],
        friendRequests: [],
    },
    reducers: {
        setFriends: (state, action) => {
            state.friends = action.payload;
        },
        setPendingFriends: (state, action) => {
            state.pendingFriends = action.payload;
        },
        setFriendRequests: (state, action) => {
            state.friendRequests = action.payload;
        },
    },
});

export const {
    setFriends,
    setFriendRequests,
    setPendingFriends,
} = friendSlice.actions;

export default friendSlice.reducer;
